import { Table, TableBody, TableCell, TableRow, styled } from '@mui/material';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LicenseComparision } from '../../models';

const DenseTableCell = styled(TableCell)({ borderBottom: 0, padding: '8px 16px' });

export const LicenseComparator: FC<LicenseComparision> = ({ activeLicenseStatus, uploadedLicenseStatus }) => {
  const { t } = useTranslation();
  const mergedQuantityDetails = useMemo<Record<string, number>>(() => {
    const current = activeLicenseStatus?.quantityDetails ?? {};
    const uploaded = uploadedLicenseStatus?.quantityDetails ?? {};

    return { ...current, ...uploaded };
  }, [activeLicenseStatus?.quantityDetails, uploadedLicenseStatus?.quantityDetails]);
  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell></TableCell>
          <TableCell variant="head">{t('license.columns.current')}</TableCell>
          <TableCell variant="head">{t('license.columns.new')}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell variant="head">{t('license.columns.productName')}</TableCell>
          <TableCell>{activeLicenseStatus?.productName ?? '-'}</TableCell>
          <TableCell>{uploadedLicenseStatus?.productName ?? '-'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell variant="head">{t('license.columns.quantity')}</TableCell>
          <TableCell>{activeLicenseStatus?.quantity ?? '-'}</TableCell>
          <TableCell>{uploadedLicenseStatus?.quantity ?? '-'}</TableCell>
        </TableRow>
        {Object.keys(mergedQuantityDetails).map(key => (
          <TableRow key={key}>
            <DenseTableCell>{t([`license.quantityDetails.${key}`, key])}</DenseTableCell>
            <DenseTableCell>{activeLicenseStatus?.quantityDetails?.[key] ?? '-'}</DenseTableCell>
            <DenseTableCell>{uploadedLicenseStatus?.quantityDetails?.[key] ?? '-'}</DenseTableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell variant="head">{t('license.columns.type')}</TableCell>
          <TableCell>{activeLicenseStatus?.type ?? '-'}</TableCell>
          <TableCell>{uploadedLicenseStatus?.type ?? '-'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell variant="head">{t('license.columns.licenseVersion')}</TableCell>
          <TableCell>{activeLicenseStatus?.licenseVersion ?? '-'}</TableCell>
          <TableCell>{uploadedLicenseStatus?.licenseVersion ?? '-'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell variant="head">{t('license.columns.licenseExpireAt')}</TableCell>
          <TableCell>
            {activeLicenseStatus?.licenseExpireAt
              ? t('dateTime.short', {
                  date: new Date(activeLicenseStatus.licenseExpireAt),
                })
              : '-'}
          </TableCell>
          <TableCell>
            {uploadedLicenseStatus?.licenseExpireAt
              ? t('dateTime.short', { date: new Date(uploadedLicenseStatus.licenseExpireAt) })
              : '-'}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
